import { Dispatch, FC, SetStateAction, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { RedoOutlined, UndoOutlined } from '@ant-design/icons'
import { Flex, Modal, Table, theme, Typography } from 'antd'
import { ColumnType } from 'antd/es/table'

import { Country } from '../../components/icon/Country'

import { Context } from './Context'

const columns: ColumnType<TrackCardFragment>[] = [
  {
    dataIndex: ['country'],
    title: <FormattedMessage id={'track.country'} />,
    render: (country: string) => <Country country={country} />,
    align: 'center',
  },
  {
    title: <FormattedMessage id={'track.name'} />,
    render: (value: TrackCardFragment) => (
      <Flex>
        <Typography.Text ellipsis>{value.name}</Typography.Text>
      </Flex>
    ),
    fixed: 'left',
  },
  {
    title: <FormattedMessage id={'track.total-length'} />,
    dataIndex: ['totalLength'],
    align: 'center',
    sorter: (a, b) => (a?.totalLength ?? 0) - (b?.totalLength ?? 0),
  },
  {
    title: <FormattedMessage id={'track.longest-straight-length'} />,
    dataIndex: ['longestStraightLength'],
    align: 'center',
    sorter: (a, b) => (a?.longestStraightLength ?? 0) - (b?.longestStraightLength ?? 0),
  },
  {
    title: <FormattedMessage id={'track.direction'} />,
    dataIndex: ['direction'],
    align: 'center',
    render: (value) =>
      value === 'CLOCK_WISE' ? <RedoOutlined style={{ fontSize: 20 }} /> : <UndoOutlined style={{ fontSize: 20 }} />,
  },
  {
    title: <FormattedMessage id={'track.right-corners'} />,
    dataIndex: ['rightCorners'],
    align: 'center',
    sorter: (a, b) => (a?.rightCorners ?? 0) - (b?.rightCorners ?? 0),
  },
  {
    title: <FormattedMessage id={'track.left-corners'} />,
    dataIndex: ['leftCorners'],
    align: 'center',
    sorter: (a, b) => (a?.leftCorners ?? 0) - (b?.leftCorners ?? 0),
  },
]

const ComparingModal: FC<{ open: boolean; setOpen: Dispatch<SetStateAction<boolean>> }> = ({ open, setOpen }) => {
  const { data, checked } = useContext(Context)
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()
  return (
    <Modal
      title={formatMessage({ id: 'rider.compare.title' })}
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
      footer={null}
      width={1200}
    >
      <Table
        size={'small'}
        style={{ overflow: 'scroll' }}
        rowHoverable={false}
        rowKey={(it) => it.documentId}
        onRow={() => ({ style: { backgroundColor: token.colorBgContainer } })}
        showHeader={true}
        pagination={{ hideOnSinglePage: true }}
        dataSource={checked
          ?.map((it) => data?.find((r) => r?.slug === it) as TrackCardFragment)
          .map((it) => ({
            ...it,
          }))}
        columns={columns}
      />
    </Modal>
  )
}

export { ComparingModal }
